import React, { useState, useEffect, useContext } from "react";
import { ethers } from "ethers";
import { Box, Button, Heading, Text } from "@chakra-ui/react";
import { AppContext } from "../../AppContext";
import JakobWallet from "../../contracts/BlindfoldWalletV2.json";
import { positionRouterAddress } from "../../config";
import { formatAddress } from './../../utils/formatMetamask';

const ApproveExchangeRouter = ({ setRouterStatus }) => {
  const { account, fastestWebSocket, contractAddress } = useContext(AppContext);

  const [isApproved, setIsApproved] = useState(false);

  useEffect(() => {
    checkPluginApproval();
  }, [contractAddress]);

  const contractABI = JakobWallet.abi;

  const checkPluginApproval = async () => {
    try {
      const provider = new ethers.providers.WebSocketProvider(fastestWebSocket);
      const contract = new ethers.Contract(
        contractAddress,
        contractABI,
        provider,
      );
      const isApproved = await contract.isPluginApproved(
        contractAddress,
        positionRouterAddress,
      );
      setIsApproved(isApproved);
    } catch (error) {
      console.error("Error checking Position Router plugin approval:", error);
    }
  };

  const handleApprovePlugin = async () => {
    try {
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const signer = provider.getSigner();
      const contract = new ethers.Contract(
        contractAddress,
        contractABI,
        signer,
      );

      const tx = await contract.approvePositionRouter();
      setRouterStatus("Approving Position Router as plugin...");
      await tx.wait();
      setRouterStatus("Plugin Position Router approved successfully!");
      setIsApproved(true);
    } catch (error) {
      console.error("Error approving plugin:", error);
      setRouterStatus("Error approving plugin.");
    }
  };

  return (
    <Box p={1}>
      <Heading as="h3" size="md">
        Approve Exchange Router
      </Heading>
      <Text>Plugin Approved: {isApproved.toString()}</Text>
      {!isApproved && (
        <Button
          mt={4}
          colorScheme="red"
          width="100%"
          onClick={handleApprovePlugin}
        >
          Approve Plugin
        </Button>
      )}
    </Box>
  );
};

export default ApproveExchangeRouter;
